// 上线前屏蔽所有的 console.log（不影响报错显示）
if (process.env.NODE_ENV === 'production') {
  console.log = function () {};
}

import Vue from 'vue'
import App from './App.vue'
import FeedbackModal from '@/components/FeedbackModal.vue'
import router from './router'
import store from './store'
import ElementUI, { Message, MessageBox } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/global.css'
import { hasSensitiveWord, filterSensitiveWord } from '@/utils/sensitiveFilter'

Vue.config.productionTip = false
Vue.use(ElementUI)

// ========= 全局方法：敏感词 =========
Vue.prototype.$hasSensitiveWord = hasSensitiveWord
Vue.prototype.$filterSensitiveWord = filterSensitiveWord

// ========= 全局方法：轻提示 =========
// 用法：this.$showToast('提示内容')
Vue.prototype.$showToast = (msg, type = 'warning') => {
  Message({ 
    message: msg, 
    type, 
    duration: 2500, 
    showClose: true,
    customClass: 'global-toast-top',
    zIndex: 999999 // 👈 强行设置一个极大的层级
  })
}

// ========= 全局方法：确认弹窗（Promise 版）=========
// 用法：const ok = await this.$showConfirm('确定吗？'); if(!ok) return
Vue.prototype.$showConfirm = (msg, title = '提示') => {
  return MessageBox.confirm(msg, title, {
    confirmButtonText: '继续',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => true).catch(() => false)
}
// 全局打开反馈弹窗（不依赖 this）
Vue.prototype.$openFeedback = function () {
  if (typeof window !== 'undefined' && typeof window.__openFeedback === 'function') {
    window.__openFeedback()
  }
}
// ========= 全局覆写 window.alert，用 element-ui 顶部提示条代替 =========
window.alert = (msg) => {
  const text = String(msg)
  // 智能判断类型
  let type = 'warning'
  if (/成功|完成|已复制|已刷新|已加入|已删除|已撤销/.test(text)) {
    type = 'success'
  } else if (/失败|错误|无效|不能|请先登录|请填写|请输入|不存在|已存在/.test(text)) {
    type = 'error'
  }
  Message({
    message: text.replace(/\n/g, '<br/>'),
    type,
    duration: 2500,
    showClose: true,
    dangerouslyUseHTMLString: true
  })
}

Vue.component('FeedbackModal', FeedbackModal)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')